import moment from 'moment';

export const TriggeredFormatter = ({ value }) => moment(value).format('MM/DD/YYYY H:mm:ss');
